import { render, staticRenderFns } from "./CreatePartitionModal.vue?vue&type=template&id=6ae27640&"
import script from "./CreatePartitionModal.vue?vue&type=script&lang=js&"
export * from "./CreatePartitionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports